<script setup lang="ts">
  import { MpText } from '@borg/ui';

  const props = withDefaults(
    defineProps<{
      bold?: boolean;
    }>(),
    {
      bold: false,
    },
  );

  const projectConfig = useProjectConfig();

  const almaCookiesSettings = _almaCookiesSettings.inject();

  function openAlmaCookiesSettings() {
    almaCookiesSettings.openSettings();
  }
</script>

<template>
  <a
    v-if="projectConfig.features.almaCookieManager"
    class="alma-cookie-settings"
    :class="{ 'alma-cookie-settings--bold': props.bold }"
    @click="openAlmaCookiesSettings"
  >
    <MpText
      no-margin
      :semibold="props.bold"
    >
      {{ $t('BRAND_LINKS.COOKIES.LABEL') }}
    </MpText>
  </a>
</template>

<style scoped lang="scss">
  .alma-cookie-settings {
    text-decoration: none;
    cursor: pointer;

    &--bold {
      font-weight: var(--mp-font-weight-bold);
    }
  }
</style>
